import { render, staticRenderFns } from "./mod-web-footer.vue?vue&type=template&id=cda4eaf2&"
import script from "./mod-web-footer.vue?vue&type=script&lang=js&"
export * from "./mod-web-footer.vue?vue&type=script&lang=js&"
import style0 from "./mod-web-footer.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports